import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
import "./page_policy.css";

const PagePolicy = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <div id="policy" class="mb-8 rounded-lg bg-white p-6 shadow">
      <h1>QUY CHẾ BẢO VỆ DỮ LIỆU CÁ NHÂN</h1>
      <p>
        <strong>
          CỦA NGƯỜI DÙNG SỬ DỤNG DỊCH VỤ DỊCH THUẬT AUDIO/VIDEO CỦA WEBSITE THỪA
          PHÁT LẠI
        </strong>
      </p>

      <div class="preamble">
        <p>
          <strong>Căn cứ:</strong>
        </p>
        <ul>
          <li>
            Nghị định 13/2023/NĐ-CP ngày 17/4/2023 của Chính phủ về bảo vệ dữ
            liệu cá nhân;
          </li>
          <li>
            Nhu cầu thu thập, xử lý dữ liệu cá nhân nhằm cung cấp dịch vụ dịch
            thuật tự động, cải tiến chất lượng hệ thống và đảm bảo quyền lợi
            người dùng;
          </li>
        </ul>
        <p>
          <strong>CÔNG TY CỔ PHẦN TỔ CHỨC PHÁT TRIỂN VÌ VIỆT NAM</strong> (sau
          đây gọi là "Chúng tôi") ban hành Quy chế này để quy định nguyên tắc
          bảo vệ dữ liệu cá nhân của người dùng sử dụng dịch vụ trên website.
        </p>
      </div>

      <h2>Điều 1. Sự Đồng ý Thu thập Dữ liệu Cá nhân</h2>
      <p>
        <strong>1.1.</strong> Việc thu thập, xử lý dữ liệu cá nhân của người
        dùng chỉ được thực hiện khi có sự <strong>đồng ý rõ ràng</strong> thông
        qua:
      </p>
      <ul>
        <li>Tích chọn ô đồng ý khi đăng ký tài khoản hoặc sử dụng dịch vụ;</li>
        <li>Xác nhận bằng văn bản điện tử (email, tin nhắn).</li>
      </ul>
      <p>
        <strong>1.2.</strong> Chúng tôi có quyền sửa đổi, bổ sung hoặc cập nhật
        Quy chế này vào bất kỳ thời điểm nào. Việc người dùng tiếp tục truy cập
        hoặc sử dụng dịch vụ sau khi Quy chế được cập nhật sẽ được coi là sự
        đồng ý ràng buộc đối với toàn bộ nội dung Quy chế mới. Trường hợp người
        dùng không đồng ý với Quy chế đã cập nhật, người dùng hiểu và chấp thuận
        rằng Chúng tôi có quyền đơn phương chấm dứt việc cung cấp dịch vụ sau
        thời hạn thông báo trước 30 (ba mươi) ngày làm việc. Mọi khoản phí hoặc
        số tiền mà người dùng đã thanh toán trước đó nhưng chưa sử dụng (nếu có)
        sẽ bị coi là chi phí phát sinh cho việc duy trì dịch vụ và
        <strong>không được hoàn lại dưới bất kỳ hình thức nào</strong>.
      </p>
      <p>
        <strong>1.3.</strong> Người dùng có quyền từ chối cung cấp dữ liệu,
        nhưng điều này có thể ảnh hưởng đến khả năng sử dụng đầy đủ tính năng
        dịch vụ.
      </p>

      <h2>Điều 2. Phạm vi Dữ liệu Cá nhân Được Thu thập</h2>
      <strong>2.1. Thông tin bắt buộc:</strong>
      <ul>
        <li>Họ tên, địa chỉ email, số điện thoại;</li>
        <li>Địa chỉ IP, thiết bị sử dụng, trình duyệt;</li>
        <li>Lịch sử tương tác với dịch vụ (tệp tải lên, bản dịch đã tạo).</li>
      </ul>
      <strong>2.2. Thông tin tự động thu thập:</strong>
      <ul>
        <li>Dữ liệu âm thanh/video được người dùng tải lên để dịch thuật;</li>
        <li>Bản dịch kết quả và dữ liệu sửa lỗi (nếu có);</li>
        <li>
          Dữ liệu nhật ký hệ thống, dữ liệu định vị, cookies, và dữ liệu hành vi
          duyệt web liên quan đến dịch vụ.
        </li>
        <li>Thời gian sử dụng, tần suất truy cập.</li>
      </ul>
      <strong>2.3. Thông tin bổ sung (tùy chọn):</strong>
      <ul>
        <li>
          Giọng nói, hình ảnh cá nhân (nếu người dùng sử dụng tính năng nhận
          diện giọng nói/hình ảnh);
        </li>
        <li>Thông tin thanh toán (nếu sử dụng dịch vụ trả phí).</li>
      </ul>

      <h2>Điều 3. Mục đích Xử lý Dữ liệu</h2>
      <p>
        <strong>Dữ liệu cá nhân được sử dụng cho các mục đích sau:</strong>
      </p>
      <ol>
        <li>Cung cấp dịch vụ dịch thuật audio/video thành văn bản;</li>
        <li>
          Cải thiện chất lượng thuật toán dịch thuật thông qua việc phân tích dữ
          liệu ở dạng ẩn danh hoặc tổng hợp;
        </li>
        <li>
          Hỗ trợ kỹ thuật, giải quyết sự cố và phản hồi yêu cầu từ người dùng;
        </li>
        <li>
          Xác minh danh tính, bảo mật tài khoản và ngăn chặn hành vi gian lận;
        </li>
        <li>
          Gửi thông báo cập nhật dịch vụ, bản cập nhât, chương trình khuyến mại
          hoặc chính sách (nếu người dùng không từ chối nhận);
        </li>
        <li>
          Chia sẻ dữ liệu ẩn danh cho mục đích nghiên cứu khoa học, thống kê,
          phát triển công nghệ (nếu người dùng không từ chối);
        </li>
        <li>
          Thực hiện các nghĩa vụ pháp lý, bao gồm nhưng không giới hạn ở việc
          xuất hóa đơn, cung cấp thông tin hoặc báo cáo cho cơ quan nhà nước có
          thẩm quyền khi được yêu cầu.
        </li>
      </ol>

      <h2>Điều 4. Đối tượng Tiếp cận Dữ liệu</h2>
      <strong>4.1. Bên trong:</strong>
      <p>
        Nhân viên được ủy quyền của Dịch Vụ Chuyển Âm Website có trách nhiệm bảo
        mật dữ liệu.
      </p>
      <strong>4.2. Bên thứ ba:</strong>
      <ul>
        <li>
          Đối tác công nghệ (cung cấp máy chủ, giải pháp AI) ký kết thỏa thuận
          bảo mật;
        </li>
        <li>Cơ quan nhà nước có thẩm quyền khi có yêu cầu bằng văn bản;</li>
        <li>Nhà cung cấp dịch vụ thanh toán (nếu có).</li>
      </ul>

      <h2>Điều 5. Phương thức Xử lý Dữ liệu</h2>
      <p>
        <strong>5.1.</strong> Dữ liệu được xử lý tự động bằng công nghệ AI và
        lưu trữ trên hệ thống đám mây được mã hóa.
      </p>
      <p>
        <strong>5.2.</strong> Các hành vi xử lý bao gồm: thu thập, ghi âm,
        chuyển đổi văn bản, lưu trữ, phân tích, xóa.
      </p>
      <p>
        <strong>5.3.</strong> Dữ liệu nhạy cảm (giọng nói, hình ảnh) được mã hóa
        đầu cuối và chỉ lưu trữ trong thời gian cần thiết.
      </p>
      <p>
        <strong>5.4.</strong> Lưu trữ, sao lưu, tái sử dụng, chuyển giao dữ liệu
        dưới dạng ẩn danh hoặc tổng hợp.
      </p>

      <h2>Điều 6. Thời hạn Lưu trữ Dữ liệu</h2>
      <p>
        <strong>6.1. Dữ liệu người dùng:</strong> Lưu trữ đến khi tài khoản bị
        xóa hoặc người dùng yêu cầu hủy bỏ.
      </p>
      <p>
        <strong>6.2. Bản dịch kết quả:</strong> Lưu trữ tối đa 12 tháng kể từ
        ngày tạo, sau đó tự động xóa.
      </p>
      <p>
        <strong>6.3. Ngoại lệ:</strong> Dữ liệu có thể được lưu trữ lâu hơn thời
        hạn nêu trên cho mục đích bảo vệ quyền lợi hợp pháp của Chúng tôi hoặc
        nếu còn tranh chấp chưa giải quyết.
      </p>

      <h2>Điều 7. Quyền và Nghĩa vụ của Người dùng</h2>
      <strong>7.1. Quyền:</strong>
      <ul>
        <li>Truy cập, chỉnh sửa, xóa dữ liệu cá nhân;</li>
        <li>Rút lại đồng ý bất kỳ lúc nào;</li>
        <li>Khiếu nại vi phạm bảo mật dữ liệu.</li>
      </ul>
      <strong>7.2. Nghĩa vụ:</strong>
      <ul>
        <li>Cung cấp thông tin chính xác;</li>
        <li>
          Người dùng phải tự chịu trách nhiệm về dữ liệu đã tải lên và đảm bảo
          có quyền sở hữu/hợp pháp sử dụng dữ liệu đó.
        </li>
        <li>
          Người dùng cam kết đơn phương chịu trách nhiệm và không liên đới đến
          Công ty nếu dữ liệu họ cung cấp vi phạm pháp luật, quyền sở hữu trí
          tuệ, hoặc quyền của bên thứ ba.
        </li>
        <li>
          Không sử dụng dịch vụ để tải lên dữ liệu vi phạm pháp luật hoặc xâm
          phạm quyền người khác.
        </li>
      </ul>

      <h2>Điều 8. Cơ chế Thực hiện Quyền Người dùng</h2>
      <p>
        <strong>8.1.</strong> Người dùng tự quản lý dữ liệu qua:
      </p>
      <ul>
        <li>Tài khoản cá nhân trên website;</li>
        <li>Gửi yêu cầu đến email: admin@viae.vn.</li>
      </ul>
      <p>
        <strong>8.2. Thời gian phản hồi yêu cầu:</strong> 05 ngày làm việc.
      </p>
      <p>
        <strong>8.3.</strong> Chúng tôi có quyền từ chối hoặc giới hạn yêu cầu
        chỉnh sửa/xóa dữ liệu nếu ảnh hưởng đến nghĩa vụ pháp lý hoặc quyền lợi
        hợp pháp của Công ty.
      </p>

      <h2>Điều 9. Cam kết Bảo mật</h2>
      <strong>9.1. Chúng tôi áp dụng các biện pháp kỹ thuật:</strong>
      <ul>
        <li>Mã hóa dữ liệu truyền và lưu trữ;</li>
        <li>Tường lửa, hệ thống phát hiện xâm nhập;</li>
        <li>Đào tạo nhân viên về bảo mật thông tin.</li>
      </ul>
      <strong>9.2. Miễn trừ trách nhiệm:</strong>
      <ul>
        <li>
          Không chịu trách nhiệm nếu dữ liệu bị rò rỉ do lỗi người dùng (ví dụ:
          tiết lộ mật khẩu);
        </li>
        <li>
          Không chịu trách nhiệm về tổn thất gián tiếp, hệ quả, mất dữ liệu, mất
          lợi nhuận do việc sử dụng dịch vụ.
        </li>
        <li>
          Không chịu trách nhiệm nếu bên thứ ba tấn công hệ thống dù đã áp dụng
          biện pháp bảo mật tối đa.
        </li>
      </ul>

      <h2>Điều 10. Giới hạn Trách nhiệm</h2>
      <p>
        <strong>10.1.</strong> Trong mọi trường hợp, tổng mức trách nhiệm bồi
        thường của Chúng tôi đối với bất kỳ yêu cầu, khiếu nại hoặc thiệt hại
        nào phát sinh từ hoặc liên quan đến việc sử dụng dịch vụ sẽ không vượt
        quá số tiền dịch vụ mà người dùng đã thực tế thanh toán cho Chúng tôi
        trong vòng 06 (sáu) tháng liền kề trước thời điểm phát sinh sự kiện gây
        ra trách nhiệm.
      </p>
      <p>
        <strong>10.2.</strong> Chúng tôi không chịu trách nhiệm đối với bất kỳ
        thiệt hại gián tiếp, hệ quả, mất mát dữ liệu, mất lợi nhuận, hoặc mất cơ
        hội kinh doanh nào của người dùng, kể cả khi đã được thông báo trước về
        khả năng xảy ra những thiệt hại đó.
      </p>
      <p>
        <strong>10.3.</strong> Người dùng đồng ý bồi thường, bảo vệ và giữ cho
        Chúng tôi không bị thiệt hại trước mọi khiếu nại, yêu cầu, tổn thất hoặc
        chi phí (bao gồm cả phí luật sư hợp lý) do việc người dùng vi phạm Quy
        chế này hoặc pháp luật có liên quan.
      </p>

      <h2>Điều 11. Thông tin Liên hệ</h2>
      <div class="contact-info">
        <p>
          <strong>Đơn vị thu thập dữ liệu:</strong> CÔNG TY CỔ PHẦN TỔ CHỨC PHÁT
          TRIỂN VÌ VIỆT NAM
        </p>
        <p>
          <strong>Địa chỉ:</strong> A15/78, Ấp 1A, Xã Vĩnh Lộc B, Huyện Bình
          Chánh, Thành phố Hồ Chí Minh, Việt Nam
        </p>
        <p>
          <strong>Điện thoại:</strong> 079 722 2227
        </p>
        <p>
          <strong>Email:</strong> admin@viae.vn
        </p>
      </div>

      <h2>Điều 12. Hiệu lực Thi hành</h2>
      <p>
        <strong>12.1.</strong> Quy chế này có hiệu lực thi hành kể từ ngày{" "}
        <strong>01/01/2024</strong> và sẽ ràng buộc toàn bộ người dùng đã giao
        kết Điều khoản sử dụng dịch vụ với Công ty.
      </p>
      <p>
        <strong>12.2.</strong> Mọi tranh chấp phát sinh liên quan đến việc sử
        dụng dịch vụ trước hết được giải quyết thông qua thương lượng, hòa giải
        thiện chí. Trường hợp không đạt được thỏa thuận trong vòng 30 (ba mươi)
        ngày kể từ ngày phát sinh tranh chấp, tranh chấp sẽ được đưa ra giải
        quyết tại Tòa án Nhân dân TP. Hồ Chí Minh. Luật áp dụng là pháp luật
        Việt Nam.
      </p>
      <p>
        <strong>12.3.</strong> Chúng tôi có quyền đơn phương sửa đổi, bổ sung
        hoặc cập nhật Quy chế này định kỳ. Thông tin cập nhật sẽ được thông báo
        đến người dùng qua email đăng ký hoặc đăng tải công khai trên website.
        Việc người dùng tiếp tục sử dụng dịch vụ sau thời điểm Quy chế được cập
        nhật được coi là sự đồng ý và chấp thuận ràng buộc theo toàn bộ nội dung
        Quy chế mới.
      </p>
      <p>
        <strong>12.4.</strong> Chúng tôi không chịu trách nhiệm đối với bất kỳ
        thiệt hại, tổn thất hoặc khiếu nại nào của người dùng phát sinh do việc
        người dùng không đọc, không theo dõi, hoặc không nắm rõ các nội dung Quy
        chế đã được cập nhật, mặc dù thông báo đã được gửi hoặc đăng tải công
        khai.
      </p>
    </div>
  );
};
export default PagePolicy;
